import dayjs, { Dayjs } from 'dayjs';

/**
 * Años cumplidos según su fecha de nacimiento, o `undefined` si no la sabemos (sin fecha, fecha
 * inválida o futura). Sin edad no se inventa una: los planes de ciclo de vida se proyectan con el
 * 50/50 de siempre en vez de con los tramos de una edad supuesta (Arca-Team/product#32).
 */
export function ageFromBirthdate(
	birthdate: string | null | undefined,
	today: Dayjs = dayjs()
): number | undefined {
	if (!birthdate) return undefined;
	const born = dayjs(birthdate);
	if (!born.isValid() || born.isAfter(today)) return undefined;
	return today.diff(born, 'year');
}
